import React from "react";
import { Sparkles } from "lucide-react";

function MenuHero() {
  return (
    <section className="menu-hero">
      <h1>
        The Art of <i>Taste.</i>
      </h1>
    </section>
  );
}

export default React.memo(MenuHero);
